import { config } from "../utilities/configs";
import { http } from "../utilities/http";

let BookCallService = {
  add: async (request) => {
    const resp = await http.post(config.baseUrl + "/book-call", request);
    return resp;
  },
};

export { BookCallService }; 